export function fromApiDate(value: string): Date {
  const date = new Date(value);

  return Number.isNaN(date.valueOf()) ? new Date(0) : date;
}
